export enum TipoReferenciaEnum {
  Bancaria = 1,
  Comercial,
}
